import React, { useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import PropTypes from 'prop-types';

import { buscarDadosCliente } from '~/auth';
import { Loading } from '~/components';
import Layout from '~/views/Layout';

import routes from './routesUrl';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const {
    keycloak: { authenticated },
    initialized,
  } = useKeycloak();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!initialized) {
          return <Loading active text="Acessando o sistema..." />;
        }

        if (authenticated === false) {
          window.location = process.env.REACT_APP_CONTA_URL;
          return null;
        }
        return <Component {...props} {...rest} />;
      }}
    />
  );
};

function Routes() {
  const {
    keycloak: { authenticated },
  } = useKeycloak();

  const initialRender = useCallback(async () => {
    if (authenticated) buscarDadosCliente();
  }, [authenticated]);

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  return (
    <Router>
      <Switch>
        <Layout>
          {routes.map((route) =>
            route.private ? (
              <PrivateRoute {...route} />
            ) : (
              <Route {...route}>
                <route.component {...route} />
              </Route>
            )
          )}
        </Layout>
      </Switch>
    </Router>
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default Routes;
